import React from "react";
import "./Plans.css";

function Plans() {
  return (
    <div className="plans">
      <h3>Premium : Rs 799 </h3>
      <h6>Resolution - 4K+HDR</h6>
    </div>
  );
}

export default Plans;
